// extracted by mini-css-extract-plugin
export default {"root":"WalletTotalAssetChart_root__B0CuY","title":"WalletTotalAssetChart_title__k4YPe","chart":"WalletTotalAssetChart_chart__So83r","refresh":"WalletTotalAssetChart_refresh__lHfDY"};